import { TinyEmitter } from 'tiny-emitter';
import { Material, MaterialDetail, MaterialType, SubtitleSegmented } from '@/interface.ts';
import { AudioMode } from '@/components/Timeline/utils.ts';

// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
interface EditEvent {
  emit(event: 'audio-text-modified', materialId: number, text: string): this;
  on(event: 'audio-text-modified', cb: (materialId: number, text: string) => void): this;
  emit(event: 'translation-text-modified', materialId: number, text: string): this;
  on(event: 'translation-text-modified', cb: (materialId: number, text: string) => void): this;
  emit(event: 'audio-speaker-modified', materialId: number, speakerId: number): this;
  on(event: 'audio-speaker-modified', cb: (materialId: number, speakerId: number) => void): this;
  emit(event: 'translation-speaker-modified', materialId: number, speakerId: number): this;
  on(
    event: 'translation-speaker-modified',
    cb: (materialId: number, speakerId: number) => void,
  ): this;
  emit(event: 'audio-subtitle-modified', materialId: number, text: string): this;
  on(event: 'audio-subtitle-modified', cb: (materialId: number, text: string) => void): this;
  emit(event: 'translation-subtitle-modified', materialId: number, text: string): this;
  on(event: 'translation-subtitle-modified', cb: (materialId: number, text: string) => void): this;
  emit(event: 'audio-updated', material: MaterialDetail, type: string): this;
  on(event: 'audio-updated', cb: (material: MaterialDetail, type: string) => void): this;
  emit(event: 'translation-updated', material: MaterialDetail, type: string): this;
  on(event: 'translation-updated', cb: (material: MaterialDetail, type: string) => void): this;
  emit(event: 'material-inserted', material: MaterialDetail, nextId: number): this;
  on(event: 'material-inserted', cb: (material: MaterialDetail, nextId: number) => void): this;
  emit(event: 'material-deleted', material: MaterialDetail): this;
  on(event: 'material-deleted', cb: (material: MaterialDetail) => void): this;
  emit(event: 'translation-language-changed'): this;
  on(event: 'translation-language-changed', cb: () => void): this;
  emit(event: 'audio-generating', material: MaterialDetail): this;
  on(event: 'audio-generating', cb: (material: MaterialDetail) => void): this;
  emit(event: 'translation-generating', material: MaterialDetail): this;
  on(event: 'translation-generating', cb: (material: MaterialDetail) => void): this;
  emit(event: 'segmente-subtitle-modified', type: AudioMode, material: Material): this;
  on(event: 'segmente-subtitle-modified', cb: (type: AudioMode, material: Material) => void): this;
  emit(
    event: 'add-subtitle-segmented',
    type: MaterialType,
    subtitle_segmented: SubtitleSegmented,
  ): this;
  on(
    event: 'add-subtitle-segmented',
    cb: (type: MaterialType, subtitle_segmented: SubtitleSegmented) => void,
  ): this;
  emit(event: 'audio-text-edit', materialId: number, isEdit: boolean): this;
  on(event: 'audio-text-edit', cb: (materialId: number, isEdit: boolean) => void): this;
  emit(event: 'translation-text-edit', materialId: number, isEdit: boolean): this;
  on(event: 'translation-text-edit', cb: (materialId: number, isEdit: boolean) => void): this;
  emit(event: 'audio-generating-all', materials: MaterialDetail[]): this;
  on(event: 'audio-generating-all', cb: (materials: MaterialDetail[]) => void): this;
  emit(event: 'translation-generating-all', materials: MaterialDetail[]): this;
  on(event: 'translation-generating-all', cb: (materials: MaterialDetail[]) => void): this;
  emit(event: 'retranslation-subtitle', material: MaterialDetail, type: AudioMode): this;
  on(
    event: 'retranslation-subtitle',
    cb: (material: MaterialDetail, type: AudioMode) => void,
  ): this;
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
class EditEvent extends TinyEmitter {
  constructor() {
    super();
  }
}
export const EditEventBus = new EditEvent();

// 更改翻译语言
export function changeTranslation() {
  EditEventBus.emit('translation-language-changed');
}

// 新增 material新增的detail对象 nextId 下一句话的id 最后一句话传-1
export function insertMaterial(material: MaterialDetail, nextId: number) {
  EditEventBus.emit('material-inserted', material, nextId);
}

export function generatingSentence(material: MaterialDetail) {
  if (material.type === MaterialType.AUDIO) {
    EditEventBus.emit('audio-generating', material);
  } else if (material.type === MaterialType.TRANSLATION) {
    EditEventBus.emit('translation-generating', material);
  }
}

// 更新 material更新后的detail对象  （延迟） tts
export function updateMaterial(material: MaterialDetail, type: string) {
  if (material.type === MaterialType.AUDIO) {
    EditEventBus.emit('audio-updated', material, type);
  } else if (material.type === MaterialType.TRANSLATION) {
    EditEventBus.emit('translation-updated', material, type);
  }
}
// 删除 material当前删除的detail对象
export function deleteMaterial(material: MaterialDetail) {
  EditEventBus.emit('material-deleted', material);
}
// 更新句子文本  type 1原文 4 译文
export function modifySentence(type: MaterialType, id: number, text: string) {
  if (type === MaterialType.AUDIO) {
    EditEventBus.emit('audio-text-modified', id, text);
  } else if (type === MaterialType.TRANSLATION) {
    EditEventBus.emit('translation-text-modified', id, text);
  }
}

// 更新句子speaker  type 1原文 4 译文
export function modifySpeaker(type: MaterialType, id: number, speakerId: number) {
  if (type === MaterialType.AUDIO) {
    EditEventBus.emit('audio-speaker-modified', id, speakerId);
  } else if (type === MaterialType.TRANSLATION) {
    EditEventBus.emit('translation-speaker-modified', id, speakerId);
  }
}

// 更新字幕type 1原文 4 译文
export function modifySubtitle(type: MaterialType, id: number, text: string) {
  if (type === MaterialType.AUDIO) {
    EditEventBus.emit('audio-subtitle-modified', id, text);
  } else if (type === MaterialType.TRANSLATION) {
    EditEventBus.emit('translation-subtitle-modified', id, text);
  }
}

// 字幕重新分词
export function modifySegmenteSubtitle(type: AudioMode, material: Material) {
  EditEventBus.emit('segmente-subtitle-modified', type, material);
}

// 添加字幕
export function addSubtitleSegmented(type: MaterialType, subtitle_segmented: SubtitleSegmented) {
  EditEventBus.emit('add-subtitle-segmented', type, subtitle_segmented);
}

// 更新句子编辑状态  type 1原文 4 译文
export function modifySentenceEditState(type: MaterialType, id: number, isEdit: boolean) {
  if (type === MaterialType.AUDIO) {
    EditEventBus.emit('audio-text-edit', id, isEdit);
  } else if (type === MaterialType.TRANSLATION) {
    EditEventBus.emit('translation-text-edit', id, isEdit);
  }
}

// 批量TTS
export function generatingSentenceAll(materials: MaterialDetail[]) {
  if (materials.length <= 0) return;
  if (materials[0].type === MaterialType.AUDIO) {
    EditEventBus.emit('audio-generating-all', materials);
  } else if (materials[0].type === MaterialType.TRANSLATION) {
    EditEventBus.emit('translation-generating-all', materials);
  }
}

// 字幕重新翻译
export function reTranslationSubtitle(material: MaterialDetail, type: AudioMode) {
  EditEventBus.emit('retranslation-subtitle', material, type);
}
